import { csrfHeaders, handleJson } from "@/lib/json-request"
import type {
  TaskNotificationsPage,
  TaskNotificationsState,
  TaskNotificationsSummary,
} from "@/types/task-notifications"

const NOTIFICATIONS_PATH = "/company/task_notifications"

type Ok = { ok: boolean }

export async function fetchTaskNotifications(
  state: TaskNotificationsState,
  beforeId: number | null,
  signal?: AbortSignal,
) {
  const params = new URLSearchParams({ state })
  if (beforeId != null) params.set("before_id", String(beforeId))
  const res = await fetch(`${NOTIFICATIONS_PATH}?${params.toString()}`, {
    headers: csrfHeaders(),
    credentials: "same-origin",
    signal,
  })
  return handleJson<Ok & TaskNotificationsPage>(res)
}

export async function fetchTaskNotificationsSummary(signal?: AbortSignal) {
  const res = await fetch(`${NOTIFICATIONS_PATH}/summary`, {
    headers: csrfHeaders(),
    credentials: "same-origin",
    signal,
  })
  return handleJson<Ok & { summary: TaskNotificationsSummary }>(res)
}

export async function readAllTaskNotifications() {
  const res = await fetch(`${NOTIFICATIONS_PATH}/read_all`, {
    method: "POST",
    headers: csrfHeaders(),
    credentials: "same-origin",
  })
  return handleJson<Ok & { summary: TaskNotificationsSummary }>(res)
}
